<template>
	<div class="workcontext" :style="{ height: `${windowHeight}px`, 'overflow-y': 'auto' }">
		<el-card class="box-card">
			<el-row class="workform">
				<el-col :span="14">
					<table class="table">
						<tr>
							<td class="td1"><span>问题类型</span></td>
							<td style="text-align:left;">
								<el-select size="mini" ref="q_type" v-model="form.q_type" placeholder="请选择问题类型" @keyup.native="val => enterinput(val,'','p_pkval')">
									<el-option v-for="item in q_typelist" :key="item.d_name" :label="item.d_name" :value="item.d_name"></el-option>
								</el-select>
							</td>
							<td class="td2"><span>单 号</span></td>
							<td><el-input size="mini" ref="p_pkval" v-model="form.p_pkval" @blur="checkpkval" @keyup.native="val => enterinput(val,'q_type','q_title')"></el-input></td>
						</tr>
					</table>

					<el-form ref="form" :model="form" label-width="80px" size="small">
						<el-form-item label="标      题"><el-input ref="q_title" v-model="form.q_title" @keyup.native="val => enterinput(val,'p_pkval','context')"></el-input></el-form-item>
						<el-form-item label="问题描述"><el-input ref="context" type="textarea" rows="5" v-model="form.q_context" @keyup.native="val => enterinput(val,'q_title','q_contact')"></el-input></el-form-item>
						<el-form-item label="联系方式"><el-input ref="q_contact" v-model="form.q_contact" placeholder="可输入电话\邮箱等等" @keyup.native="val => enterinput(val,'context')"></el-input></el-form-item>
						<el-form-item label="">
							<el-upload
								name="fileupload"
								class="upload-demo"
								:auto-upload="false"
								:action="uploadurl"
								:file-list="fileList"
								:on-change="UploadChange"
								:on-error="UploadError"
								:on-success="UploadSuccess"
								:show-file-list="false"
								ref="upload"
							>
								<el-button size="mini" type="primary">添加附件</el-button>
								<span style="font-size:9pt;padding-left:5px">每个文件不超过20M</span>
							</el-upload>
							<el-tag
								:style="index == 0 ? '' : 'margin-left:10px'"
								v-for="(file, index) in fileList"
								:key="index"
								closable
								size="mini"
								effect="plain"
								@close="delfile(index)"
							>
								{{ file.name }}
							</el-tag>
						</el-form-item>
					</el-form>
				</el-col>
			</el-row>
		</el-card>
		<el-row style="margin-top:20px">
			<el-col :span="6" style="color: transparent;">1</el-col>
			<el-col :span="14">
				<el-button size="small" type="success" @click="submitwork">提交</el-button>
				<el-button size="small" @click="goback">返回</el-button>
			</el-col>
		</el-row>
	</div>
</template>
<script>
import Utils from '../../lib/util.js';
export default {
	components: {},
	props: {
		urlparam: {
			type: Object,
			default: {}
		}
	},
	data() {
		return {
			form: {
				q_type: '',
				q_title: '',
				q_context: '',
				p_pkval: '',
				q_contact: '',
				u_userid: localStorage.getItem('userid'),
				u_account: localStorage.getItem('u_account')
			},
			windowHeight: window.innerHeight - 110,
			fileList: [],
			q_typelist: [],
			uploadurl: '',
			successcount: 0,
			filenamelist: [],
			uploadbatch: '' ,//上传批次号
			divclass:'workcontext'
		};
	},
	mounted() {
		this.$apipost.get.getTheme().then(res => {
			import('../../static/' + res + '/style/workorders/workorders.scss');
		});
		this.init();
	},
	methods: {
		init() {
			this.uploadbatch = this.$tool.getGuid();
			this.uploadurl = this.$apiprototype.ApiServer + '/Works/UploadWorkFile?domain=' + this.$apiprototype.WebServer + '&uploadbatch=' + this.uploadbatch;
			//获取问题类型
			this.Getqtype();
		},
		//获取问题类型
		async Getqtype() {
			var that = this;
			this.$apipost.get.dic({ type: '问题类型' }).then(res => {
				if (res != '') {
					that.q_typelist = res.data.list;
				}
			});
		},
		//上传附件改变时
		UploadChange(file, fileList) {
			var that = this;
			if (fileList.length > 0) {
				var list = [];
				fileList.forEach(e => {
					const isLt20M = e.size / 1024 / 1024 < 20;
					if (!isLt20M) {
						this.$tool.message(e.name + '已超过20M,不允许上传', 0);
						this.$refs.upload.abort(e);
					} else {
						list = list.concat(e);
					}
				});
				that.fileList = list;
			}
		},
		UploadError(err, file, fileList) {
			console.log('上传错误 error', err);
		},
		//上传成功
		UploadSuccess(res, file, fileList) {
			console.log('成功', file);
			if(this.filenamelist.length>0){
				this.filenamelist=this.filenamelist.concat({name:res.filename});
			}
			else{
				this.filenamelist=[{name:res.filename}];
			}
			this.successcount = parseInt(this.successcount) + 1;
			if (this.successcount == this.fileList.length) {
				//全部上传完成
				console.log('全部上传完成');
				this.uploadbatch = res.batch;
				this.savework();
			}
		},
		//移除上传的文件
		delfile(index) {
			this.$refs.upload.abort(this.fileList[index]);
			this.fileList.splice(index, 1);
		},
		//检测单号
		checkpkval() {
			var that=this;
			if (this.form.p_pkval != '') {
				this.$apipost.get.CheckOrderPkval({ pkval: this.form.p_pkval }).then(res => {
					if(res.state=='0'){
						this.$tool.message(res.message, 0);
						that.$refs["p_pkval"].focus();
						return false;
					}
				});
			}
		},
		//提交服务单
		submitwork() {
			if (this.fileList.length > 0) {
				this.$refs.upload.submit();
			} else {
				this.savework();
			}
		},
		//提交服务单2
		savework() {
			if (this.form.q_type == '') {
				this.$tool.message('请选择问题类型', 0);
				return false;
			}
			if (this.form.q_title == '') {
				this.$tool.message('请填写标题', 0);
				return false;
			}
			if (this.form.q_context == '') {
				this.$tool.message('请填写问题描述', 0);
				return false;
			}
			var paraminfo = {
				form: this.form,
				filenamelist: this.filenamelist,
				uploadbatch: this.uploadbatch
			};
			var that=this;
			//提交问题
			this.$tool.loading('正在提交',this.divclass);
			this.$apipost.post.SaveWork({ paraminfo: paraminfo }).then(res => {
				this.$tool.loadingclose();
				if (res != '') {
					that.successcount=0;
					if (res.state == '1') {
						this.$tool.message('提交成功', 1);
						setTimeout(function() {
							that.goback();
						}, 2000);
					} else this.$tool.message(res.message, 0);
				}
			});
		
		
		},
		//返回
		goback() {
			Utils.$emit('handleRermove', localStorage.getItem('tabname'));
		},
		enterinput(event,perv,next) {
			if (event.keyCode != undefined) {
				if (event.keyCode == 13 || event.keyCode == 39) {
					if (next!= '') this.$refs[next].focus();
				} else if (event.keyCode == 37) {
					if (perv != '') this.$refs[perv].focus();
				}
			}
		}
	}
};
</script>

<style></style>
